import { Button, Chip, Stack } from '@mui/material';
import { isEqual } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_MANUFACTURER_FILTER } from 'store/slices/manufacturerManagementSlice';
import { filterManufacturers } from 'store/thunks/manufacturerManagementThunk';

const STATUS_LABELS = { ACTIVE: 'Active', INACTIVE: 'Inactive' };

const ManufacturerManagementFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ inventory }) => inventory.manufacturerManagement.filter);

  const removeFilter = (key) => () =>
    dispatch(filterManufacturers({ filter: { ...filter, [key]: undefined } }));

  // Resets to the screen's default view (Active), not to "everything".
  const reset = () => dispatch(filterManufacturers({ filter: DEFAULT_MANUFACTURER_FILTER }));

  return (
    <Stack direction='row' spacing={0.75} flexWrap='wrap' alignItems='center'>
      {filter.manufacturer && (
        <Chip
          size='small'
          label={`Manufacturer = ${filter.manufacturer}`}
          variant='contained'
          onDelete={removeFilter('manufacturer')}
        />
      )}
      <Chip
        size='small'
        label={`Status = ${STATUS_LABELS[filter.status] ?? 'All'}`}
        variant='contained'
        onDelete={filter.status ? removeFilter('status') : undefined}
      />
      {!isEqual(filter, DEFAULT_MANUFACTURER_FILTER) && (
        <Button size='small' onClick={reset} sx={{ fontSize: 12 }}>
          Reset
        </Button>
      )}
    </Stack>
  );
};

export default ManufacturerManagementFilterStatusBar;
